function stepOneReduser(state = {
  redirectToStepTwo:false,
  }, action) {
    switch (action.type) {
      case 'SET_REDIRECT':
        return {
          ...state,
          redirectToStepTwo: action.redirectToStepTwo,
        };
      default:
        return state;
    }
  }
  
  
  export default stepOneReduser
  
  
  


// WEBPACK FOOTER //
// src/reducers/stepOneReduser.js